<button
  class="{{ type() }} {{ buttonStyleClass() }} {{
    disabled() ? 'opacity-50' : ''
  }}"
>
  <ng-content />
</button>
